document.addEventListener('DOMContentLoaded', function() {

  // Thumbnail switcher
  document.querySelectorAll('.product-media__thumb').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var thumbs = btn.closest('.product-media__thumbs');
      thumbs.querySelectorAll('.product-media__thumb').forEach(function(b) {
        b.classList.remove('is-active');
      });
      btn.classList.add('is-active');
      var img = document.getElementById('main-product-image');
      if (img) img.src = btn.dataset.src;
    });
  });

  // Option selector
  var form = document.getElementById('product-form');
  if (form) {
    var variantInput = form.querySelector('[name="id"]');
    var variantsEl = document.getElementById('product-variants-json');
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    form.querySelectorAll('.option-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var idx = btn.dataset.optionIndex;
        form.querySelectorAll('.option-btn[data-option-index="' + idx + '"]').forEach(function(b) {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');
        var sel = [0,1,2].map(function(i) {
          var a = form.querySelector('.option-btn[data-option-index="' + i + '"].is-selected');
          return a ? a.dataset.value : null;
        }).filter(Boolean);
        var match = variants.find(function(v) {
          var opts = [v.option1, v.option2, v.option3].filter(Boolean);
          return sel.every(function(s, i) { return opts[i] === s; });
        });
        if (match && variantInput) {
          variantInput.value = match.id;
          var atc = form.querySelector('.btn-atc');
          if (atc) {
            atc.disabled = !match.available;
            atc.textContent = match.available ? 'Add to Cart' : 'Sold Out';
          }
        }
      });
    });

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var body = new URLSearchParams(new FormData(form));
      fetch('/cart/add.js', {
        method: 'POST',
        body: body,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function() {
        return fetch('/cart.js');
      }).then(function(r) {
        return r.json();
      }).then(function(cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function(el) {
          el.textContent = cart.item_count;
        });
      });
    });
  }

});